import React from 'react';
import IntroduceTab from 'components/menu/company/IntroduceTab';
import CITab from 'components/menu/company/CITab';
import VisionTab from 'components/menu/company/VisionTab';
import HistoryTab from 'components/menu/company/HistoryTab';
import OrganizationTab from 'components/menu/company/OrganizationTab';
import LocationTab from 'components/menu/company/LocationTab';
import PageFrame from 'components/common/PageFrame';
import menuItems from 'assets/data/menuItems.json';

const showTab = (id) => {
    switch (id) {
        case 0:
            return <IntroduceTab />
        case 1:
            return <CITab />
        case 2:
            return <VisionTab />
        case 3:
            return <HistoryTab />
        case 4:
        //    return <OrganizationTab />
        //case 5:
            return <LocationTab />
        default: return;
    }
}

const CompanyPage = () => {

    return (
        <section className='CompanyPage'>
            <PageFrame subMenuItems={menuItems[0].tabs} showTab={showTab} rest={33} page={'company'} />
        </section>
    );
};

export default React.memo(CompanyPage);